import React from 'react';
import Customer1 from '../../asset/Home/Customers/customer1.png';
import Customer2 from '../../asset/Home/Customers/customer2.png';
import Customer3 from '../../asset/Home/Customers/customer3.png';
import Customer4 from '../../asset/Home/Customers/customer4.png';
import Customer5 from '../../asset/Home/Customers/customer5.png';
import Customer7 from '../../asset/Home/Customers/customer7.png';
import Customer8 from '../../asset/Home/Customers/customer8.png';
import Customer9 from '../../asset/Home/Customers/customer9.png';
import Customer10 from '../../asset/Home/Customers/customer10.png';
import Customer11 from '../../asset/Home/Customers/customer11.png';
import Customer12 from '../../asset/Home/Customers/customer12.png';
import Customer13 from '../../asset/Home/Customers/customer13.png';
import Customer14 from '../../asset/Home/Customers/customer14.png';

const caseStudies = [
  { id: 1, url: 'https://hinomaru.tokyo/', image: Customer1 },
  { id: 2, url: 'https://www.iseyasu.com/', image: Customer2 },
  { id: 3, url: 'https://alpha-bright.co.jp/', image: Customer3 },
  { id: 4, url: 'https://netamoto.co.jp/', image: Customer4 },
  { id: 5, url: 'https://www.fields.biz/ir/j/', image: Customer5 },
  { id: 7, url: 'http://signpost.host/', image: Customer7 },
  { id: 8, url: 'http://yorokobi3656.html.xdomain.jp/', image: Customer8 },
  { id: 9, url: 'https://tsubasa-shishinkai.com/', image: Customer9 },
  { id: 10, url: 'https://www.yoshidapharma.com/', image: Customer10 },
  { id: 11, url: 'https://morinosato.biz/', image: Customer11 },
  { id: 12, url: 'http://www17.plala.or.jp/zeshinkai/', image: Customer12 },
  { id: 13, url: 'http://www.japan-fpc.or.jp/', image: Customer13 },
  { id: 14, url: 'https://www.i-seijinkai.jp/"', image: Customer14 },

];

const Casestudy = () => (
  <>
    <div className="d-flex flex-wrap">
      {
        caseStudies.map((item) => (
          <a key={item.id} className="case-study-img my-2 col-4 col-lg-3 px-2" href={item.url}>
            <img style={{ width: '100%', height: '100%' }} src={item.image} alt="導入事例" />
          </a>
        ))
      }
    </div>
  </>
);

export default Casestudy;
